// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 4h-isvtBnlNT
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicClientPaymentsCard.module.css"; // plasmic-import: 4h-isvtBnlNT/css

createPlasmicElementProxy;

export const PlasmicClientPaymentsCard__VariantProps = new Array();

export const PlasmicClientPaymentsCard__ArgProps = new Array(
  "amount",
  "paymentType",
  "paymentDate"
);

const $$ = {};

function PlasmicClientPaymentsCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__r7Ek9)}>
        {renderPlasmicSlot({
          defaultContents: "$1043.00",
          value: args.amount,
          className: classNames(sty.slotTargetAmount)
        })}
      </div>
      <Stack__
        as={"div"}
        data-plasmic-name={"paymentStatusStack"}
        data-plasmic-override={overrides.paymentStatusStack}
        hasGap={true}
        className={classNames(projectcss.all, sty.paymentStatusStack)}
      >
        <div
          data-plasmic-name={"rectangle56"}
          data-plasmic-override={overrides.rectangle56}
          className={classNames(projectcss.all, sty.rectangle56)}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"Paid"}
          </div>
        </div>
      </Stack__>
      <div className={classNames(projectcss.all, sty.freeBox__vqmNo)}>
        {renderPlasmicSlot({
          defaultContents: "Escrow Payment",
          value: args.paymentType,
          className: classNames(sty.slotTargetPaymentType)
        })}
      </div>
      <div
        data-plasmic-name={"paymentDate"}
        data-plasmic-override={overrides.paymentDate}
        className={classNames(projectcss.all, sty.paymentDate)}
      >
        {renderPlasmicSlot({
          defaultContents: "Dec 28th, 12:25 AM",
          value: args.paymentDate,
          className: classNames(sty.slotTargetPaymentDate)
        })}
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "paymentStatusStack", "rectangle56", "text", "paymentDate"],
  paymentStatusStack: ["paymentStatusStack", "rectangle56", "text"],
  rectangle56: ["rectangle56", "text"],
  text: ["text"],
  paymentDate: ["paymentDate"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicClientPaymentsCard__ArgProps,
          internalVariantPropNames: PlasmicClientPaymentsCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicClientPaymentsCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicClientPaymentsCard";
  } else {
    func.displayName = `PlasmicClientPaymentsCard.${nodeName}`;
  }
  return func;
}

export const PlasmicClientPaymentsCard = Object.assign(
  // Top-level PlasmicClientPaymentsCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    paymentStatusStack: makeNodeComponent("paymentStatusStack"),
    rectangle56: makeNodeComponent("rectangle56"),
    text: makeNodeComponent("text"),
    paymentDate: makeNodeComponent("paymentDate"),
    // Metadata about props expected for PlasmicClientPaymentsCard
    internalVariantProps: PlasmicClientPaymentsCard__VariantProps,
    internalArgProps: PlasmicClientPaymentsCard__ArgProps
  }
);

export default PlasmicClientPaymentsCard;
/* prettier-ignore-end */
